import React, { useEffect, useState, useRef } from "react";
import EmpaticaIcon from "../../recursos/EmpaticaIcon.png";
import EmpaticaIconBlanco from "../../recursos/empatica-hor-blanco.png";
import fondo from "../../recursos/Fondo-1.png";
import image1 from "../../recursos/Fondo-PTA.png";
import image2 from "../../recursos/Fondo-SISCOM.png";
import medidor from "../../recursos/Medidor.png";
import hand from "../../recursos/Handheld.png";
import paginas from "../../recursos/Img-paginas.png";
import eficiencia from "../../recursos/Eficiencia-icon.png";
import tiempo from "../../recursos/Bajo-Tiempo-Icon.png";
import esp from "../../recursos/Especializacion-Icon.png";
import sol from "../../recursos/Soluciones-icon.png";
import '../Publico/styles/test.css';
import { Menu, X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { useInView } from "react-intersection-observer";
import CountUp from 'react-countup';
import fondo2 from "../../recursos/Fondo-ciudad.png";
import Footer2 from "./Footer2";
import logo1 from "../../recursos/SMAPAU.png";
import logo2 from "../../recursos/SAPA.png";
import logo3 from "../../recursos/JLAPAS.png";
import logo4 from "../../recursos/JUMAPAA.png";
import logo5 from "../../recursos/JAPASP.png";
import logo6 from "../../recursos/JAPAC.png";
import logo7 from "../../recursos/COMAPATAC.png";
import logo8 from "../../recursos/COMAPA-Querendaro.png";
import logo9 from "../../recursos/CMAPA.png";
import logo10 from "../../recursos/CAPALAC.png";
import logo11 from "../../recursos/OOAPAS-GZ.png";
import logo12 from "../../recursos/OOAPAS-Huandacareo.png";
import logo13 from "../../recursos/PTA.png";
import logo14 from "../../recursos/SIMAPAS.png";
import logo15 from "../../recursos/SIAMM.png";
import logo16 from "../../recursos/SAPASMA.png";
import fondoinfo from "../../recursos/Fondo-info-texto.png";
import empaticaRegular from "../../fonts/Branding-Semilight.otf";
import empaticaBold from "../../fonts/Branding-Bold.otf";
import empaticaMedium from "../../fonts/Branding-Medium.otf";
import flecha from "../../recursos/flecha-izquierda.png";
import logopta from "../../recursos/Logo-PTA-Colores.png";
import logosiscom from "../../recursos/SISCOM-LOGO.png";
import ptabco from "../../recursos/Logo-PTA-Bco.png";
import siscombco from "../../recursos/SISCOM-LOGO-Bco.png";
import chatbot from "../../recursos/BOT.png";
import qp101 from "../../recursos/QP101.png";
import { Link } from 'react-router-dom';
import ChatWidget from "../ChatWidget";
import ordenador from "../../recursos/ordenador-portatil.png";
import bot2 from "../../recursos/BOT2.png";
import seg from "../../recursos/seguridad.png";
import integracion from "../../recursos/integracion-de-sistema.png";
import gobMex from "../../recursos/gobierno-electronico.png";
import graf from "../../recursos/grafico-de-barras.png";
import axios from "axios";

const PublicPage = () => {


    const [carouselRef, carouselInView] = useInView({ triggerOnce: true, threshold: 0.2 });
    const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.2 });
    const [hoveredIndex, setHoveredIndex] = useState(null);


    const bubbleVariants = {
        hidden: { opacity: 0, scale: 0.8, y: 50 },
        visible: (i) => ({
            opacity: 1,
            scale: 1,
            y: 0,
            transition: {
                delay: i * 0.05,
                duration: 1,
                ease: "easeOut",
            },
        }),
    };

    const productos = [
        { src: hand, alt: "Producto 1", detalles: "Dispositivo portátil diseñado para facilitar la lectura de medidores en campo. Permite capturar datos, registrar imágenes, geolocalizar ubicaciones y sincronizar información en tiempo real con el sistema central.", titulo: "Handheld" },
        { src: paginas, alt: "Producto 2", detalles: "Transforma tu comunidad con sitios web accesibles que facilitan pagos en línea, trámites 24/7 y comunicación transparente, optimizando la gestión pública con seguridad y diseño responsivo.", titulo: "Páginas Web para Organismos y Municipios" },
        { src: qp101, alt: "Producto 3", detalles: "Cajero inteligente ideal para oficinas de gobierno u organismos operadores. Permite a los ciudadanos realizar pagos de forma autónoma, reducir filas y mejorar la experiencia de atención.", titulo: "Quickpay101" },
        { src: medidor, alt: "Producto 4", detalles: "Tecnología avanzada para medición precisa del consumo de agua, sin piezas móviles y con mayor vida útil: Permiten monitoreo remoto, detección de fugas y lecturas en tiempo real, mejorando la transparencia y el control del servicio.", titulo: "Medidores ultrasónicos de agua" },
        { src: chatbot, alt: "Producto 5", detalles: "Asistente virtual vía WhatsApp que brinda soporte automatizado 24/7 a los usuarios. Permite consultar saldo, obtener referencias de pago, reportar fallas y recibir atención inmediata sin necesidad de llamar o acudir a oficinas.", titulo: "Chatbot de atención" },
    ];

    const alianzas = [
        { src: logo1, alt: "Logo 1" },
        { src: logo2, alt: "Logo 2" },
        { src: logo3, alt: "Logo 3" },
        { src: logo4, alt: "Logo 4" },
        { src: logo5, alt: "Logo 5" },
        { src: logo6, alt: "Logo 6" },
        { src: logo7, alt: "Logo 7" },
        { src: logo8, alt: "Logo 8" },
        { src: logo9, alt: "Logo 9" },
        { src: logo10, alt: "Logo 10" },
        { src: logo11, alt: "Logo 11" },
        { src: logo12, alt: "Logo 12" },
        { src: logo13, alt: "Logo 13" },
        { src: logo14, alt: "Logo 14" },
        { src: logo15, alt: "Logo 15" },
        { src: logo16, alt: "Logo 16" },
    ];

    const tarjetas = [
        {
            imagen: image1,
            logo: logopta,
            logoHover: ptabco,
            logosAdicionales: [ // Array con los 3 logos adicionales
                { src: ordenador, alt: "Logo Alianza 1" },
                { src: bot2, alt: "Logo Alianza 2" },
                { src: seg, alt: "Logo Alianza 3" }
            ],
            texto: "Plataforma en línea que permite a los ciudadanos consultar su saldo y realizar el pago de su servicio de agua de forma rápida, segura y sin necesidad de acudir a las oficinas. Funciona 24/7 y está diseñada para integrarse con sistemas municipales y estatales."
        },
        {
            imagen: image2,
            logo: logosiscom,
            logoHover: siscombco,
            logosAdicionales: [
                { src: integracion, alt: "Logo Alianza 4" },
                { src: gobMex, alt: "Logo Alianza 5" },
                { src: graf, alt: "Logo Alianza 6" }
            ],
            texto: "Sistema de gestión comercial que permite a los organismos operadores de agua administrar su padrón de usuarios, generar estados de cuenta, controlar pagos, aplicar recargos y llevar un seguimiento integral del servicio, todo desde una plataforma centralizada."
        },
    ];

    const [startIndex, setStartIndex] = useState(0);
    const [menuOpen, setMenuOpen] = useState(false);
    const [tarjetaDetalle, setTarjetaDetalle] = useState(null);
    const [visibleCount, setVisibleCount] = useState(3);
    const totalSlides = productos.length - visibleCount + 1;
    const [mostrarDetalles, setMostrarDetalles] = useState(false);
    const touchStartX = useRef(null);
    const touchEndX = useRef(null);
    const handleNextSlide = () => {
        setStartIndex((prev) => Math.min(prev + 1, productos.length - visibleCount));
    };

    const handlePrevSlide = () => {
        setStartIndex((prev) => Math.max(prev - 1, 0));
    };


    const handleTouchStart = (e) => {
        touchStartX.current = e.changedTouches[0].clientX;
    };

    const handleTouchEnd = (e) => {
        touchEndX.current = e.changedTouches[0].clientX;
        handleSwipe();
    };

    const handleSwipe = () => {
        if (touchStartX.current !== null && touchEndX.current !== null) {
            const distance = touchStartX.current - touchEndX.current;
            const threshold = 50;

            if (distance > threshold) {

                handleNextSlide();
            } else if (distance < -threshold) {

                handlePrevSlide();
            }
            touchStartX.current = null;
            touchEndX.current = null;
        }
    };



    const cardVariants = {
        hidden: {
            opacity: 0,
            y: 50,
            scale: 0.95
        },
        visible: {
            opacity: 1,
            y: 0,
            scale: 1,
            transition: {
                type: "spring",
                stiffness: 120,
                damping: 20,
                duration: 0.5
            }
        }
    };

    const handleDotClick = (index) => {
        setStartIndex(index);
    };

    useEffect(() => {
        const updateVisibleCount = () => {
            const width = window.innerWidth;
            if (width < 640) {
                setVisibleCount(1);
            } else if (width < 1024) {
                setVisibleCount(2);
            } else {
                setVisibleCount(3);
            }
        };

        updateVisibleCount();
        window.addEventListener('resize', updateVisibleCount);
        return () => window.removeEventListener('resize', updateVisibleCount);
    }, []);

    useEffect(() => {
        // Evita duplicar el script si ya existe
        if (document.querySelector('script[src="https://crm.empatica.mx/js/form_embed.js"]')) {
            setIsScriptLoaded(true);
            return;
        }

        const s = document.createElement("script");
        s.src = "https://crm.empatica.mx/js/form_embed.js";
        s.async = true;
        s.onload = () => setIsScriptLoaded(true);
        s.onerror = () => console.error("No se pudo cargar https://crm.empatica.mx/js/form_embed.js");
        document.body.appendChild(s);

        // Si prefieres limpiar al desmontar, descomenta el return:
        // return () => document.body.removeChild(s);
    }, []);

    useEffect(() => {
        const compute = () => {
            const vw = window.innerWidth;
            const vh = window.innerHeight;

            // Factor por ancho de dispositivo (más chico => más alto)
            let f = 1.2;
            if (vw <= 360) f = 2.2;
            else if (vw <= 400) f = 2.0;
            else if (vw <= 480) f = 1.8;
            else if (vw <= 640) f = 1.5;
            else if (vw <= 768) f = 1.3;
            else f = 1.2;

            // Ajuste en landscape (ancho > alto)
            if (vw > vh) f = Math.max(1.1, f - 0.3);

            // Altura base del widget del proveedor (1002 px) vs viewport escalado
            const minH = Math.max(1002, Math.round(vh * f));

            setPanelMinH(minH);   // misma altura para imagen y formulario
            setIframeMinH(minH);  // asegura ver el botón dentro del iframe
        };

        compute();
        let raf;
        const onResize = () => {
            cancelAnimationFrame(raf);
            raf = requestAnimationFrame(compute);
        };

        window.addEventListener('resize', onResize);
        window.addEventListener('orientationchange', onResize);
        return () => {
            window.removeEventListener('resize', onResize);
            window.removeEventListener('orientationchange', onResize);
            cancelAnimationFrame(raf);
        };
    }, []);

    const [panelMinH, setPanelMinH] = useState(1100);
    const [iframeMinH, setIframeMinH] = useState(1100);

    const [nombre, setNombre] = useState("");
    const [correo, setCorreo] = useState("");
    const [telefono, setTelefono] = useState("");
    const [mensaje, setMensaje] = useState("");
    const [mensajeEnviado, setMensajeEnviado] = useState(false);
    const [isScriptLoaded, setIsScriptLoaded] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const res = await axios.post("https://asistencia.ssclick.mx/contacto/guardar", {
                nombre,
                correo,
                telefono,
                mensaje,
            });

            console.log("✅ Respuesta:", res.data);

            // Mostrar mensaje de éxito
            setMensajeEnviado(true);

            // Limpiar campos
            setNombre("");
            setCorreo("");
            setTelefono("");
            setMensaje("");

            // Ocultar mensaje después de 5 segundos
            setTimeout(() => setMensajeEnviado(false), 5000);
        } catch (error) {
            console.error("❌ Error al enviar el mensaje:", error);
        }
    };


    return (
        <div className="bg-white text-gray-800 font-sans p-6 md:py-10">

            <div className="h-screen flex flex-col">
                {/* Header */}
                <header className="flex justify-between items-center pb-4 px-6 relative z-30">
                    {/* Logo */}
                    <div className="w-32">
                        <img src={EmpaticaIcon} alt="Logo Empática" className="w-full h-auto" />
                    </div>

                    {/* Menú desktop */}
                    <nav className="hidden md:flex gap-6 font-semibold uppercase textomenu">
                        <Link
                            to="/empaticapage"
                            className="hover:text-blue-700 text-blue-500  border-blue-500 pl-6"
                        >
                            Inicio
                        </Link>
                        <button
                            onClick={() => setMostrarDetalles(true)}
                            className="hover:text-blue-700 text-blue-500 border-l border-blue-500 pl-6"
                        >
                            ¿QUIÉNES SOMOS?
                        </button>
                        <a href="#productos" className="hover:text-blue-700 text-blue-500 border-l border-blue-500 pl-6">Productos</a>
                        <a href="#alianzas" className="hover:text-blue-700 text-blue-500 border-l border-blue-500 pl-6">Alianzas</a>
                        <a href="#pagar" className="hover:text-blue-700 text-blue-500 border-l border-blue-500 pl-6">Pagar</a>
                    </nav>

                    {/* Botón hamburguesa en móvil */}
                    <button
                        className="md:hidden text-blue-500"
                        onClick={() => setMenuOpen(!menuOpen)}
                    >
                        {menuOpen ? <X size={28} /> : <Menu size={28} />}
                    </button>

                    {/* Menú móvil desplegable */}
                    {menuOpen && (
                        <div className="fixed top-0 left-0 w-full h-screen bg-white shadow-md flex flex-col items-start px-6 py-4 md:hidden z-[9999]">
                            <button
                                className="self-end text-blue-500 mb-4"
                                onClick={() => setMenuOpen(false)}
                            >
                                <X size={28} />
                            </button>

                            {/* Enlace de Inicio */}
                            <Link
                                to="/empaticapage"
                                className="py-2 text-blue-500 font-semibold uppercase w-full text-left"
                                onClick={() => setMenuOpen(false)}
                            >
                                Inicio
                            </Link>

                            {/* Botón Quiénes Somos */}
                            <button
                                onClick={() => {
                                    setMostrarDetalles(true);
                                    setMenuOpen(false);
                                }}
                                className="py-2 text-blue-500 font-semibold uppercase border-t border-blue-200 w-full text-left"
                            >
                                ¿Quiénes somos?
                            </button>

                            {/* Enlaces a secciones */}
                            <a
                                href="#productos"
                                className="py-2 text-blue-500 font-semibold uppercase border-t border-blue-200 w-full"
                                onClick={() => setMenuOpen(false)}
                            >
                                Productos
                            </a>
                            <a
                                href="#alianzas"
                                className="py-2 text-blue-500 font-semibold uppercase border-t border-blue-200 w-full"
                                onClick={() => setMenuOpen(false)}
                            >
                                Alianzas
                            </a>
                            <a
                                href="#pagar"
                                className="py-2 text-blue-500 font-semibold uppercase border-t border-blue-200 w-full"
                                onClick={() => setMenuOpen(false)}
                            >
                                Pagar
                            </a>
                        </div>
                    )}
                </header>

                {/* Sección principal */}
                <section className="w-full h-[85vh] relative flex items-center justify-start px-4 sm:px-6 overflow-hidden">
                    <AnimatePresence mode="wait">
                        {mostrarDetalles ? (
                            <motion.div
                                id="quienes-somos"
                                key="detalles"
                                initial={{ opacity: 0, x: 100 }}
                                animate={{ opacity: 1, x: 0 }}
                                exit={{ opacity: 0, x: -100 }}
                                transition={{ duration: 0.6 }}
                                className="absolute inset-0 w-full h-full z-10 flex flex-col items-start justify-start bg-cover bg-center px-4 sm:px-6 pt-4 sm:pt-8 rounded-2xl"
                                style={{ backgroundImage: `url(${fondoinfo})` }}>

                                {/* Contenedor de contenido - Scroll solo en mobile */}
                                <div className="text-white text-left px-4 sm:px-0 max-w-4xl mb-4 overflow-y-auto sm:overflow-y-visible max-h-[75vh] sm:max-h-none space-y-4 py-4 w-full sm:mt-16">
                                    <p className="text-xl sm:text-3xl mb-4 sm:mb-6 font-[EmpaticaMedium] text-left">
                                        En Empatica <span className="font-[EmpaticaBold] text-xl sm:text-3xl">desarrollamos herramientas tecnológicas que fortalecen la gestión pública y mejoran la atención ciudadana.</span>
                                        Diseñamos soluciones específicas para organismos operadores de agua y entidades de gobierno que buscan optimizar sus procesos, automatizar operaciones y ofrecer un servicio más accesible, transparente y eficiente.
                                    </p>
                                    <p className="text-xl sm:text-3xl mb-4 sm:mb-6 font-[EmpaticaMedium] text-left">
                                        Desde sistemas de gestión como Siscom y Paga Tu Agua, hasta tecnologías de campo como medidores inteligentes, equipos handheld y kioscos de autoservicio. <span className="font-[EmpaticaBold] text-xl sm:text-3xl">Empatica ofrece un ecosistema integral que moderniza la relación entre instituciones y ciudadanía.</span>
                                    </p>

                                    {/* Botón posicionado debajo del texto - Alineado a la izquierda */}
                                    <div className="pt-4 pb-4 sm:pb-0 w-full flex justify-start">
                                        <button
                                            onClick={() => setMostrarDetalles(false)}
                                            className="bg-white text-blue-700 px-8 py-3 sm:px-10 sm:py-3 rounded-full font-semibold hover:bg-gray-200 transition-all duration-300 bg-gradient-to-r from-[#82b0f9] to-[#374ecd] shadow-lg hover:shadow-xl flex items-center justify-center"
                                        >
                                            <img
                                                src={flecha}
                                                alt="flecha"
                                                className="w-8 h-8 sm:w-8 sm:h-8 transform hover:translate-x-1 transition-transform object-contain"
                                            />
                                        </button>
                                    </div>
                                </div>
                            </motion.div>
                        ) : (
                            <motion.div
                                key="principal"
                                initial={{ opacity: 0, x: -100 }}
                                animate={{ opacity: 1, x: 0 }}
                                exit={{ opacity: 0, x: 100 }}
                                transition={{ duration: 0.6 }}
                                className="absolute inset-0 w-full h-full z-10 flex items-start sm:items-center justify-start bg-cover bg-center px-4 sm:px-6 pt-32 sm:pt-36 rounded-2xl"
                                style={{ backgroundImage: `url(${fondo})` }}
                            >
                                <div className="text-white max-w-xl">
                                    <img src={EmpaticaIconBlanco} alt="Empática" className="w-28 sm:w-36 mb-4" />
                                    <h1 className="texto2 text-lg sm:text-2xl lg:text-3xl leading-tight">
                                        Confianza pública respaldada <br />
                                        con más de 30 años de experiencia,
                                    </h1>
                                    <p className="mt-2 texto1 text-sm sm:text-base">
                                        facilitándole la vida a millones de personas
                                    </p>
                                    <button
                                        onClick={() => setMostrarDetalles(true)}
                                        className="w-full max-w-[14rem] sm:max-w-[16rem] h-10 sm:h-12 bg-gradient-to-r from-[#82b0f9] to-[#374ecd]
                                        mt-4 sm:mt-6 rounded-full text-white font-semibold text-sm sm:text-base tracking-wide shadow-md
                                        hover:brightness-110 transition-all duration-300 textoboton"
                                    >
                                        Más detalles
                                    </button>
                                </div>
                            </motion.div>
                        )}
                    </AnimatePresence>
                </section>
            </div>

            <section id="siscom" className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 py-10 px-4 sm:px-6">
                {tarjetas.map((tarjeta, index) => (
                    <motion.div
                        key={index}
                        className="relative rounded-3xl shadow-xl h-full bg-cover bg-center group overflow-hidden min-h-[300px]"
                        style={{ backgroundImage: `url(${tarjeta.imagen})` }}
                        initial={{ x: index === 0 ? -200 : 200, opacity: 0 }}
                        whileInView={{ x: 0, opacity: 1 }}
                        transition={{ duration: 0.8 }}
                        viewport={{ once: true }}
                    >
                        {/* Logo principal fijo - Estado normal */}
                        <img
                            src={tarjeta.logo}
                            alt={`Logo ${index + 1}`}
                            className="absolute top-4 left-4 w-16 h-auto sm:w-20 md:w-24 lg:w-28 z-10 md:top-6 md:left-6"
                        />

                        {/* Overlay al pasar el cursor */}
                        <div
                            className="absolute inset-0 opacity-0 group-hover:opacity-90 transition-opacity duration-500 z-20 p-4"
                            style={{
                                background: 'linear-gradient(135deg, rgba(130, 176, 248, 1) 12%, rgba(55, 78, 205, 1) 84%)',
                            }}
                        >
                            {/* Logo principal hover - Misma posición que el estado normal */}
                            <motion.img
                                src={tarjeta.logoHover}
                                alt={`Logo hover ${index + 1}`}
                                className="absolute top-4 left-4 w-16 h-auto sm:w-20 md:w-24 lg:w-28 z-30 md:top-6 md:left-6"
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                transition={{ duration: 0.4, delay: 0.2 }}
                            />

                            {/* Contenedor para logos adicionales y texto - Centrado */}
                            <div className="h-full flex flex-col items-center justify-center">
                                {/* Logos adicionales - Centrados */}
                                <motion.div
                                    className="flex justify-center gap-4 mb-6"
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    transition={{ delay: 0.3 }}
                                >
                                    {tarjeta.logosAdicionales.map((logo, i) => (
                                        <div key={i} className=" bg-opacity-90 rounded-full p-2 flex items-center justify-center mt-2 sm:mt-12">
                                            <img
                                                src={logo.src}
                                                alt={logo.alt}
                                                className="w-10 h-10 sm:w-12 sm:h-12 object-contain md:w-24 md:h-24 sm:mt-8"
                                            />
                                        </div>
                                    ))}
                                </motion.div>

                                {/* Texto */}
                                <motion.div
                                    initial={{ opacity: 0, y: 10 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.4, delay: 0.6 }}
                                    className="text-white text-center w-full px-4"
                                >
                                    <p className="text-sm sm:text-lg md:text-xl font-[EmpaticaMedium] leading-snug">
                                        {tarjeta.texto}
                                    </p>
                                </motion.div>
                            </div>
                        </div>
                    </motion.div>
                ))}
            </section>

            <motion.section
                id="productos"
                ref={carouselRef}
                initial={{ opacity: 0, y: 50 }}
                animate={carouselInView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 1, ease: "easeOut" }}
                className="w-full h-[85vh] bg-white flex flex-col justify-between px-6 py-4"
                style={{ color: 'black' }}>
                <h2 className="subtitle text-center mb-8 mt-4 tracking-tight sm:tracking-wide md:tracking-normal">
                    OTROS <br className="block sm:hidden" /> PRODUCTOS
                </h2>

                <div className="flex gap-x-6 w-full h-full overflow-x-auto scroll-smooth snap-x snap-mandatory px-4 sm:px-0 scrollbar-hide" onTouchStart={handleTouchStart}
                    onTouchEnd={handleTouchEnd}>
                    {productos
                        .slice(startIndex, startIndex + visibleCount)
                        .map((producto, idx) => {
                            const indexReal = startIndex + idx;
                            return (
                                <div
                                    key={idx}
                                    className="relative flex-shrink-0 h-full flex flex-col justify-between items-center 
                        bg-gradient-to-b from-blue-600 to-blue-800 rounded-xl shadow snap-center
                        w-[98%] sm:w-[calc(50%-2rem)] lg:w-[calc(33.33%-2.3rem)]">
                                    {/* Contenedor de la imagen */}
                                    <div className="relative w-full h-[70%]">
                                        <img
                                            src={producto.src}
                                            alt={producto.alt}
                                            className="h-full w-full object-contain rounded-t-xl bg-white"
                                        />

                                        {/* Overlay de detalles */}
                                        {hoveredIndex === indexReal && (
                                            <div
                                                className="absolute top-0 left-0 w-full h-full rounded-xl flex flex-col justify-center items-center px-4 text-white"
                                                style={{
                                                    background: 'linear-gradient(135deg, rgba(130, 176, 248, 0.95) 12%, rgba(55, 78, 205, 0.95) 84%)',
                                                }}
                                            >
                                                <button
                                                    onClick={() => setHoveredIndex(null)}
                                                    className="absolute top-2 right-2 text-white text-2xl font-bold hover:text-red-400 transition"
                                                    aria-label="Cerrar detalles"
                                                >
                                                    &times;
                                                </button>
                                                <p className="text-2xl sm:text-2xl lg:text-2xl mb-4 text-left font-[EmpaticaBold]">
                                                    {producto.titulo}
                                                </p>
                                                <p className="text-xs sm:text-lg lg:text-xl mb-4 text-left font-[EmpaticaMedium]">
                                                    {producto.detalles}
                                                </p>
                                            </div>
                                        )}
                                    </div>

                                    {/* Contenedor del título y botón */}
                                    <div className="w-full flex flex-col items-center justify-between h-[35%] p-10">
                                        {/* Título del producto */}
                                        <div className="w-full text-center mb-2 -mt-4">
                                            <h3 className="text-sm sm:text-lg  text-white ">
                                                {producto.titulo}
                                            </h3>
                                        </div>

                                        {/* Botón */}
                                        <div className="w-full flex justify-center">
                                            <button
                                                onClick={() => setHoveredIndex(indexReal)}
                                                className="bg-gradient-to-r from-[#82b0f9] to-[#374ecd] font-semibold tracking-wide uppercase
                                                        text-white text-xs sm:text-sm md:text-base
                                                        px-4 sm:px-6 py-1.5 sm:py-2 rounded-full shadow-md 
                                                        hover:bg-gray-100 transition-all duration-300 textomenu w-full max-w-[200px]">
                                                Más detalles
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                </div>

                <div className="flex justify-center gap-3 py-4">
                    {Array.from({ length: totalSlides }).map((_, i) => (
                        <button
                            key={i}
                            onClick={() => handleDotClick(i)}
                            className={`w-6 h-6 sm:w-6 sm:h-6 rounded-full transition ${startIndex === i ? "bg-blue-800" : "bg-gray-300"}`}
                        ></button>
                    ))}
                </div>
            </motion.section>

            <div
                id="alianzas"
                ref={ref}
                className="bg-gradient-to-r from-gray-100 to-gray-400 rounded-2xl py-10 px-4 sm:px-6 my-10 mx-2 sm:mx-4 ">
                <h2 className="alianza tracking-widest mb-8 text-sm uppercase text-center">
                    Alianzas
                </h2>

                <div className="grid justify-items-center sm:justify-items-start grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-8 gap-6 max-w-6xl mx-auto px-4">
                    {alianzas.map((logo, index) => (
                        <div
                            key={index}
                            className="w-24 h-24 sm:w-28 sm:h-28 rounded-full bg-white shadow-lg flex items-center justify-center"
                        >
                            <img
                                src={logo.src}
                                alt={logo.alt}
                                className="max-w-[70%] max-h-[70%] object-contain"
                            />
                        </div>
                    ))}
                </div>
            </div>

            <div
                ref={ref}
                className="w-full px-0 py-12 flex justify-center items-center"
            >
                <div className="bg-gradient-to-b from-[#82b0f9] to-[#374ecd] rounded-2xl w-full text-center py-8 px-4 shadow-lg">
                    <p className="texttransa uppercase tracking-widest text-white mb-2">
                        Más de
                    </p>
                    <h2 className="text-5xl font-bold text-white">
                        {inView ? (
                            <CountUp
                                end={3460000}
                                duration={2}
                                separator=","
                            />
                        ) : (
                            '0'
                        )}
                    </h2>
                    <p className="texttransa uppercase tracking-widest text-white mt-2">
                        Transacciones al año
                    </p>
                </div>
            </div>


            <div className="px-6 py-12 bg-white w-full">
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: "-100px" }}
                    variants={{
                        visible: {
                            transition: { staggerChildren: 0.2 }
                        }
                    }}
                    className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    {/* Beneficio 1 - Azul */}
                    <motion.div
                        variants={cardVariants}
                        className="rounded-xl p-6 text-white flex flex-col items-center text-center shadow-md bg-gradient-to-br from-blue-700 to-indigo-700 hover:scale-[1.02] transition-transform"
                    >
                        <img
                            src={eficiencia}
                            alt="Ícono personal"
                            className="w-16 h-20 mb-4"
                        />
                        <p className="textBeneficio leading-relaxed">
                            Personal eficiente que entiende sus retos, necesidades y la resistencia al cambio en los organismos.
                        </p>
                    </motion.div>

                    {/* Beneficio 2 - Negro */}
                    <motion.div


                        variants={cardVariants}

                        className="rounded-xl p-6 text-white flex flex-col items-center text-center shadow-md bg-gray-900 hover:scale-[1.02] transition-transform"
                    >
                        <img
                            src={tiempo}
                            alt="Ícono reloj"
                            className="w-36 h-16 mb-4"
                        />
                        <p className="textBeneficio leading-relaxed">
                            Bajo tiempo de implementación. Alto impacto en su eficiencia operativa sin letras chiquitas.
                        </p>
                    </motion.div>

                    {/* Beneficio 3 - Azul */}
                    <motion.div

                        variants={cardVariants}

                        className="rounded-xl p-6 text-white flex flex-col items-center text-center shadow-md bg-gradient-to-br from-blue-700 to-indigo-700 hover:scale-[1.02] transition-transform"
                    >
                        <img
                            src={esp}
                            alt="Ícono enfoque"
                            className="w-16 h-20 mb-4"
                        />
                        <p className="textBeneficio leading-relaxed">
                            <span className="textBeneficio2">Especialización y Enfoque</span> total a los organismos de Agua potable.
                        </p>
                    </motion.div>

                    {/* Beneficio 4 - Negro */}
                    <motion.div

                        variants={cardVariants}

                        className="rounded-xl p-6 text-white flex flex-col items-center text-center shadow-md bg-gray-900 hover:scale-[1.02] transition-transform"
                    >
                        <img
                            src={sol}
                            alt="Ícono tecnología"
                            className="w-22 h-20 mb-4"
                        />
                        <p className="textBeneficio leading-relaxed">
                            Bajo tiempo de implementación. Alto impacto en su eficiencia operativa sin letras chiquitas.
                        </p>
                    </motion.div>
                </motion.div>
            </div>



            {/* CTA */}
            <section className="w-full relative flex justify-center px-4 py-12 md:py-16 my-12 md:my-16 mb-40 lg:mb-56">
                <motion.div
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, ease: "easeOut" }}
                    viewport={{ once: true }}
                    className="grid grid-cols-1 md:grid-cols-2 w-full max-w-[1600px] rounded-3xl gap-0"
                >
                    {/* Columna izquierda (imagen + texto) */}
                    <div className="relative flex items-end justify-center h-[300px] md:h-auto md:min-h-[1100px]">
                        <img
                            src={fondo2}
                            alt="Fondo ciudad"
                            className="absolute inset-0 w-full h-[95%] object-cover rounded-2xl "
                        />
                        <div className="relative z-10 p-4 md:p-12 pb-8 md:pb-14 w-full h-full flex items-end md:mb-20 md:ml-14">
                            <h3 className="titulofooter text-white leading-relaxed max-w-full md:max-w-md text-lg md:text-3xl">
                                Haz tu administración más eficiente, segura y digital.{" "}
                                <span className="titulofooter2">Escríbenos.</span>
                            </h3>
                        </div>
                    </div>

                    {/* Columna derecha (formulario embebido) */}
                    <div className="flex items-stretch px-0 py-0 md:min-h-[1100px] bg-white">
                        <motion.div
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.3, duration: 0.8 }}
                            viewport={{ once: true }}
                            className="w-full h-full"
                        >
                            {!isScriptLoaded && (
                                <div className="w-full h-full flex items-center justify-center text-sm text-gray-600">
                                    Cargando formulario…
                                </div>
                            )}

                            <iframe
                                src="https://crm.empatica.mx/widget/form/tM8Mof9yV5Xh5EoBKaCo"
                                title="Form Gobierno | Captacion"
                                id="inline-tM8Mof9yV5Xh5EoBKaCo"
                                className="w-full border-0 min-h-[1700px] sm:min-h-[1450px] md:min-h-[1200px]"
                                data-layout="{'id':'INLINE'}"
                                data-trigger-type="alwaysShow"
                                data-trigger-value=""
                                data-activation-type="alwaysActivated"
                                data-activation-value=""
                                data-deactivation-type="neverDeactivate"
                                data-deactivation-value=""
                                data-form-name="Form Gobierno | Captacion"
                                data-height="1002"
                                data-layout-iframe-id="inline-tM8Mof9yV5Xh5EoBKaCo"
                                data-form-id="tM8Mof9yV5Xh5EoBKaCo"
                                aria-label="Formulario de contacto"
                                loading="lazy"
                            />
                        </motion.div>
                    </div>
                </motion.div>
            </section>

            {/* Footer */}
            {/* <footer className="text-center text-sm text-gray-500 border-t pt-6 mt-10">
                © {new Date().getFullYear()} Empática Soluciones. Todos los derechos reservados.
            </footer> */}
            <div className="h-24 md:h-32" aria-hidden />
            <Footer2 />
            {/*<ChatWidget />*/}
            <style>
                {`
                                @font-face {
                                    font-family: 'EmpaticaMedium';
                                    src: url(${empaticaMedium}) format('opentype');
                                    font-weight: normal;
                                    font-style: normal;
                                }
            
                                @font-face {
                                    font-family: 'EmpaticaRegular';
                                    src: url(${empaticaRegular}) format('opentype');
                                    font-weight: normal;
                                    font-style: normal;
                                }
            
                                @font-face {
                                    font-family: 'EmpaticaBold';
                                    src: url(${empaticaBold}) format('opentype');
                                    font-weight: bold;
                                    font-style: normal;
                                }
            
                                @keyframes float {
                                    0% { transform: translateY(0); }
                                    50% { transform: translateY(-6px); }
                                    100% { transform: translateY(0); }
                                }
            
                                @keyframes fadeInChar {
                                    0% { opacity: 0; transform: translateY(10px); }
                                    100% { opacity: 1; transform: translateY(0); }
                                }
            
                                .animate-float {
                                    animation: float 3s ease-in-out infinite;
                                }
            
                                .animate-fade-in {
                                    animation: fadeInChar 0.3s ease forwards;
                                }
                            `}
            </style>
        </div >

    );
};


export default PublicPage;
